import { render, staticRenderFns } from "./OnePOneVCongress.vue?vue&type=template&id=458c72fc"
import script from "./OnePOneVCongress.vue?vue&type=script&lang=js"
export * from "./OnePOneVCongress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports